import { render, staticRenderFns } from "./PaginationFilter.vue?vue&type=template&id=1a4219bf&scoped=true&lang=pug&"
import script from "./PaginationFilter.vue?vue&type=script&lang=js&"
export * from "./PaginationFilter.vue?vue&type=script&lang=js&"
import style0 from "./PaginationFilter.vue?vue&type=style&index=0&id=1a4219bf&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4219bf",
  null
  
)

/* custom blocks */
import block0 from "./PaginationFilter.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports